import React, { useEffect, useContext, useState } from 'react';
import { StateContext } from '../../StateContainer';
import axios from 'axios';
import { IoCheckmarkDoneCircleSharp as IconaFatto } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';

const ModalDeleteNode = ({ onNodesDelete }) => {
  const {
    error,
    setError,
    token,
    nuovoProgetto,
    setNuovoProgetto,
    nodeToDelete,
  } = useContext(StateContext);

  const nodeName = nodeToDelete && nodeToDelete.node_label;
  return (
    <div
      className="modal fade overlay"
      id="ModalDeleteNode"
      tabIndex="-1"
      aria-labelledby="ModalDeleteNode"
      aria-hidden="true"
      data-bs-backdrop="false"
      style={{ zIndex: '99999999999999999999999999999999999' }}
    >
      <div className="modal-dialog modal-dialog-centered text-center">
        <div className="modal-content">
          <div className="modal-header border-0 py-4 text-center">
            <h5 className="modal-title text-center">
              Elimina nodo "{nodeName}"
            </h5>
          </div>
          <div className="modal-body">
            <p>Sei sicuro di voler rimuovere il nodo "{nodeName}"?</p>
          </div>
          <div className="modal-footer">
            <div className="d-flex w-100 gap-2">
              <button
                type="button"
                className="btn btn-secondary w-50"
                data-bs-dismiss="modal"
                id="ModalCancelNodeButton"
              >
                Annulla
              </button>
              <button
                type="button"
                className="btn bg-danger text-white w-50"
                onClick={() => onNodesDelete(nodeToDelete)}
                id="creaProgettoButton"
              >
                Elimina
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalDeleteNode;
